/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![XLargeIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABFklEQVR4nO1VS07DMBC14ARIkJYbVW1nPLOwZoDcJVtOAeegUhesQUIt5XMbkEup3Mp17KTLvk2iZN7HY49szAklQNJHIH1mrqsiojFmOr25RCtzIH04bGBljqQ/SLIqMRk5d4UkC8/1AQ8WTia3F0Dyujax8sV8d50jDiTLbE4JYVQqHiMC6XeM2Fk8x4S5rnqJp0yY6wqtvvcWD9MiyWpj8vH/7p8AOuglHq5km/pYyUNw2JbExncCgA522rJuU/kwtie3f2052ianhHjv39i5YS/xcUSgs0lIBKufKeL+wLWalIhHhzHFaZrmDEjeNidk4YnRwpZhRKtP0SLn3Lk/30Dy4i+PXPHd1csMSe+3H08wGfgFZjb0pFklHkAAAAAASUVORK5CYII=)
 */
export const XLargeIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19.3 20.7a1 1 0 0 0 1.4-1.4L13.42 12l7.3-7.3a1 1 0 0 0-1.42-1.4L12 10.58l-7.3-7.3a1 1 0 0 0-1.4 1.42L10.58 12l-7.3 7.3a1 1 0 1 0 1.42 1.4L12 13.42l7.3 7.3Z"
        className={colorClass}
      />
    </svg>
  );
};
